import { Injectable } from '@angular/core';

import { ApiService }       from '../../app-lite/api/api.service';
import { SessionModel }     from '../../app-lite/sessions/models/session';
import { SessionService }   from '../../app-lite/sessions/session.service';
import { UserAccountModel } from '../users/models/user.account';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor (
    private apiService    : ApiService,
    private sessionService: SessionService
  ) {}

  login ( user : UserAccountModel ) : Promise<SessionModel> {
    return this.apiService.post('/customer_portal_sessions/login', user)
    .then(( session : SessionModel ) => this.sessionService.setSession(session));
  }

  logout () : Promise<any> {
    return this.apiService.delete('/customer_portal_sessions/destroy')
    .then(() => {
      this.sessionService.clear();

      return Promise.resolve();
    });
  }
}
